import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page container">
      <h1>About Us</h1>

      <p>
        At <strong>The Westchester Music Lab</strong>, we specialize in <strong>creating high-quality audio, video, and visual content for musicians</strong>. Our mission is simple: help artists capture their work professionally and present it with clarity, impact, and confidence.
      </p>

      <p>
        Based in <strong>Mamaroneck, NY</strong>, we offer a <strong>full-service creative environment</strong> for recording performances, producing polished audio and video content, and developing strong visual branding. Our services include <Link to="/services/studio/recording">audio and video recording</Link>, 
        <Link to="/services/studio/recording"> post-production and mixing</Link>, <Link to="/services/live-sound/audio-engineer">live performance capture</Link>, and <Link to="/services/branding">graphic design</Link> for artist logos and merchandise.
      </p>

      <p>
        We work with musicians of all backgrounds — from artists preparing submission-ready recordings to professionals documenting performances and building their public presence. Every project is handled with <strong>attention to detail, technical precision, and respect for the artist’s vision.</strong>
      </p>

      <p>
        If you need your music <strong>recorded, presented, and represented professionally</strong>, <strong>The Westchester Music Lab</strong> provides the tools, experience, and creative support to make it happen.
      </p>


      {/* <p>
        At <strong>The Westchester Music Lab</strong>,  our mission is to <strong>support musicians at every stage</strong> of their careers, whether they’re picking up an instrument for the very first time, recording social media content for their established project, or preparing for their next big performance. From first notes to final mixes, we're here to bring your sound to life!
      </p>

      <p>
        Located in <strong>Mamaroneck, NY</strong>, we provide <strong>a full-service creative space</strong> where artists can <strong>learn, create, and refine</strong> their skills. Our offerings range from <Link to="/services/lessons/studio">in-studio</Link> and 
        <Link to="/services/lessons/in-home"> in-home</Link> lessons, to <Link to="/services/studio/recording">professional recording</Link>, 
        <Link to="/services/studio/recording"> mixing</Link>, and <Link to="/services/live-sound/audio-engineer">live sound services</Link>. 
        We bring <strong>industry-level production, education, and technical expertise</strong> into one accessible hub for musicians across Westchester and beyond.
      </p>

      <p>
        What sets us apart is our <strong>commitment to adaptability and personalized service.</strong> Every musician is unique, and we tailor our approach to <strong>fit each professionals creative vision, and every student’s learning style and artistic goals.</strong> Our team of dedicated professionals includes 
        <strong> experienced tutors, audio engineers, and industry specialists</strong> who are passionate about helping artists 
        <strong> grow, perform, and produce their best work.</strong>
      </p>

      <p>
        Whether you're looking to <strong>hone your craft</strong>, <Link to="/services/studio/recording">record your latest project</Link>, or ensure 
        your next <Link to="/services/live-sound/audio-engineer">live performance</Link> sounds flawless,<strong>The Westchester Music Lab</strong> is your <strong>one-stop destination for everything music.</strong>
      </p> */}

      <h3 className="call-to-action">🎶 Create. Innovate. Elevate. 🎶</h3>
    </div>
  );
};

export default AboutPage;